import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import { addUser } from '../utils/storage';
import '../styles/BindPage.css';

const BindPage = ({ onBindSuccess }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    bindType: 'idCard',
    idCard: '',
    studentId: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      alert('请输入学生姓名');
      return;
    }

    if (formData.bindType === 'idCard' && !formData.idCard.trim()) {
      alert('请输入身份证号');
      return;
    }

    if (formData.bindType === 'studentId' && !formData.studentId.trim()) {
      alert('请输入学号');
      return;
    }

    // 添加新用户
    addUser({
      name: formData.name,
      school: '新绑定学校',
      idCard: formData.bindType === 'idCard' ? formData.idCard : null,
      studentId: formData.bindType === 'studentId' ? formData.studentId : null
    });

    // 清空表单
    setFormData({
      name: '',
      bindType: 'idCard',
      idCard: '',
      studentId: ''
    });

    if (onBindSuccess) {
      onBindSuccess();
    }

    // 跳转到用户列表
    navigate('/users');
  };

  return (
    <div className="page bind-page">
      <Header title="中国近视防控大数据平台" showClose />

      <div className="bind-container">
        <form className="bind-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            className="input-field"
            placeholder="输入学生姓名"
            value={formData.name}
            onChange={handleInputChange}
          />

          <select
            name="bindType"
            className="input-field"
            value={formData.bindType}
            onChange={handleInputChange}
          >
            <option value="idCard">身份证</option>
            <option value="studentId">学号</option>
          </select>

          {formData.bindType === 'idCard' ? (
            <input
              type="text"
              name="idCard"
              className="input-field"
              placeholder="输入身份证号"
              value={formData.idCard}
              onChange={handleInputChange}
            />
          ) : (
            <input
              type="text"
              name="studentId"
              className="input-field"
              placeholder="输入学号"
              value={formData.studentId}
              onChange={handleInputChange}
            />
          )}

          <button type="submit" className="btn-primary">
            查询
          </button>
        </form>

        <div className="qr-section">
          <div className="qr-code">
            <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
              <rect width="200" height="200" fill="white"/>
              <rect x="20" y="20" width="60" height="60" fill="black"/>
              <rect x="30" y="30" width="40" height="40" fill="white"/>
              <rect x="120" y="20" width="60" height="60" fill="black"/>
              <rect x="130" y="30" width="40" height="40" fill="white"/>
              <rect x="20" y="120" width="60" height="60" fill="black"/>
              <rect x="30" y="130" width="40" height="40" fill="white"/>
              <rect x="90" y="90" width="20" height="20" fill="#4ecdc4"/>
              <text x="100" y="103" fontSize="10" fill="white" textAnchor="middle">近视</text>
              <text x="100" y="113" fontSize="10" fill="white" textAnchor="middle">防控</text>
            </svg>
          </div>
          <p className="qr-tips">
            长按关注【中国近视防控】公众号<br />
            实时获取更准确的孩子视力情况
          </p>
        </div>

        <div className="copyright">
          ©2025 版权所有 浙江清大视光科技有限公司
        </div>
      </div>
    </div>
  );
};

export default BindPage;
